<template>
    <mdb-container fluid>    
        <mdb-row v-if="layout_ready" class="justify-content-md-center bg-cover" :style="'background: #FFF url('+custom_login.BACKGROUNDIMG+') no-repeat; min-height:'+screen_height+ ';'">
           <div :style="'width:'+custom_login['box_width']" class="custom_lang_chooser_outer" role="main">
                <mdb-card class="login-box" :style="'background:'+custom_login['background_color']">
                <mdb-card-body>
                    <p v-html="custom_login.COUNTRYANNOUNCEMENTLABEL"></p>
                   <!-- Material form login 
                <form>-->
                <p class="h4 text-center mb-4" v-html="custom_login.COUNTRYLABEL"></p>
                <div class="grey-text text-center" >
                    <language-dropdown @language_drop="changeSelectVal" id="lang_drop"></language-dropdown>  

                <!-- <select name="id_language" id="id_language" aria-label="Choose Language" v-model="language_drop">
                    <option value="">Choose Language</option>
                    <template v-for="(lang,ky) in language_arr">
                    <option :lang="lang['language_abbreviation']" :value="lang['id_country_id_language']" :key="ky">{{lang['country_english']+'-'+ lang['language_native']}}</option>
                    </template>
                    
                </select> --> 
                </div>
                <div class="text-center">
                    <mdb-btn v-on:click="setLanguage" class="btn-login">Go</mdb-btn>
                </div>
                <div class="text-center" role="alert" aria-atomic="true">
                    <mdb-badge pill color="white" :v-if="err" >{{err}}</mdb-badge>
                </div>
               <!-- </form> 
             Material form login  -->
                <p v-html="custom_login.COUNTRYANNOUNCEMENTLABELDOWN"></p>
                </mdb-card-body>
                </mdb-card>            
           </div>
           <mdb-col lg ="12" class="text-center-align" role="contentinfo">
                <p v-html="custom_login['LOGINFOOTER']"></p>
            </mdb-col>
      
        </mdb-row>
        <mbd-row v-else>
            <span  role="alert" aria-live="assertive" class="sr-only">loading...</span>
            <img :src="LOCAL_HOST+'/ThemeMegazine/images/loader_dot.gif'" height="20" />
        </mbd-row>
  </mdb-container>
</template>

<script>
import axios from 'axios';
import { mdbRow, mdbContainer, mdbCol, mdbInput, mdbBtn,mdbCard, mdbCardBody,mdbBadge  } from 'mdbvue';
import LanguageDropdown from '@/components/ThemeMDB/pages/partialsCommon/LanguageDropdown';
//import {functionMixins} from '@/mixin/functionMixins';
export default {
    //mixins: [functionMixins],
    name: 'BodyLanguageChooser',    
    data(){
        return{language_drop:'',message:'',err:'',language_arr:[],api_private_key:'',
        screen_height:window.innerHeight+'px',custom_login:[], LOCAL_HOST:this.$store.state.LOCAL_HOST,
        redirect_sett:[], layout_ready:false,
        flg:false,land_abbre:''
        }
    },
    components:{
        mdbContainer,
        mdbRow,
        mdbCol,mdbInput, mdbBtn,mdbCard, mdbCardBody, mdbBadge,LanguageDropdown
    },
    created(){
        this.getCustomLogin();
        document.title="Language Selector";
    },
    mounted :function(){
        document.documentElement.setAttribute("lang", "en");
        Weglot.switchTo('en');
    },
    watch: {
        // '$store.state.themeLogic.middle.features': function() {
        //     this.flg=true;
        //     console.log('ttttt-',this.$store.state.themeLogic.middle.features)
        // }
    },
    methods:{
        // changeFlag(){
        //     this.flg=true;
        //     cosole.log('flg changed');
        // },
        getCustomLogin(){
            this.$store.state.companyData['filename']=localStorage.filename;
            if(this.$store.state.companyData['custom_login'] === undefined || this.$store.state.companyData['custom_login'].length == 0){
                const config = {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
                const formData = new FormData()
                formData.append('id_eap', this.$store.state.companyData['id_eap'])
                formData.append('filename', this.$store.state.companyData['filename'])            
            
                axios.post(this.$store.state.apiUrl+'/login_page',formData,config)
                .then(response => {
                    response = response.data
                /* if(response === undefined || response.length == 0 ){
                        //console.log('invalid')
                        this.err='! Invalid Credential / No Access'
                    }
                    else{*/
                    //console.log('ttt-'+response.COMPANYANNOUNCEMENTLABEL)
                        //this.layoutData=response;
                        this.custom_login=response 
                        this.$store.state.companyData['custom_login'] = response 
                        this.screen_height=window.innerHeight+'px'
                        //console.log('tttuyuyu-'+this.layoutData.COMPANYANNOUNCEMENTLABEL)
                        this.layout_ready=true;
                    //}
                    
                })
                .catch(() => {
                
                    this.err='Try after sometime'
                    //this.layout_ready=false;
                });
                //event.preventDefault();
        

            }else{
                this.custom_login=this.$store.state.companyData['custom_login'];
                this.layout_ready=true;
            }
           
        
        },
        changeSelectVal(value,land_abbre){
            this.language_drop=value;
            this.land_abbre=land_abbre;
        },       
        async setLanguage(){                       
            if(this.language_drop){ 
                 const config = {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
                const formData = new FormData()                      
            
                formData.append('id_company', this.$store.state.companyData['id_company']) 
                formData.append('id_eap', this.$store.state.companyData['id_eap'])
                formData.append('id_country_language', this.language_drop)
                formData.append('filename', this.$store.state.companyData['filename'])
                formData.append('username', this.$store.state.companyData['logname'])
                
                await axios.post(this.$store.state.apiUrl+'/login_redirect',formData,config)                
                .then(response => {              
                        response = response.data
                        
                        this.redirect_sett = response
                        //console.log('11-',this.redirect_sett);
                        //this.$emit('content_ld_flag_changed');                
                        this.$nextTick(function () {
                        
                        })
                    
                })
                .catch(() => {
                        this.redirect_sett = []
                });

                if(this.redirect_sett.flag=='1'){
                    //console.log('redirected',this.redirect_sett.flag)                    
                    localStorage.clear();
                    //window.location.href=this.$store.state.LOCAL_HOST+this.redirect_sett.url;
                    if(this.redirect_sett.url.substr(0,4) == 'http'){
                        window.location.href=this.redirect_sett.url;
                    } else {
                        window.location.href=this.$store.state.LOCAL_HOST+this.redirect_sett.url;
                    }
                    //this.$router.push({path:this.redirect_sett.url});
                    return false;
                }
                else{          
                     
                            
                this.$store.state.companyData['id_language'] =this.language_drop.substr(3,3)
                //alert('lngds'+this.$store.state.companyData['id_language'])
                this.$store.state.companyData['id_country'] = this.language_drop.substr(0,3)

                    //set Local storage cache      
                    // alert('cntryid'+this.$store.state.companyData['id_country'])
                    
                    localStorage.id_language = this.language_drop.substr(3,3);
                    localStorage.id_country = this.language_drop.substr(0,3);  
                    localStorage.lang_abbrevation=this.land_abbre.substr(0,2);                  
                    //console.log('test2'+localStorage.id_language)
                    document.documentElement.setAttribute("lang", localStorage.lang_abbrevation);
                    //return false
                    this.$store.dispatch('getTheme');
                    this.$store.dispatch('getLanguageTerms');
                    this.$store.dispatch('getThemeLogic');
                    this.$store.dispatch('getCompanyDataInfo');
                
                
                //alert('inhere');
               //this. rediredtme()
                    if( sessionStorage.getItem('intended_url') != '' && sessionStorage.getItem('intended_url') != null)
                    {
                        let intended_url = sessionStorage.getItem('intended_url');
                        sessionStorage.removeItem('intended_url');
                        this.$router.push({path:intended_url});
                    }
                    else
                    {
                        sessionStorage.removeItem('intended_url');
                        this.$router.push({path:'/'});
                    }
                    return false;
                }
            }else{
                this.err="Please Select Language";        
                //document.getElementById('lang_drop').focus();
            }
                                                
            event.preventDefault()
        },
         async  rediredtme() {

                let promise = new Promise((resolve, reject) => {
                    //setTimeout(() => resolve("done!"), 5000)  // =='undefined'
                    //if(isset(this.$store.state.themeLogic.middle.features))this.$store.state.companyData.length 
                try{
                    if(this.flg){
                       resolve('done');
                    }
                    
                    else{
                       this.rediredtme();  
                    }
                }catch(error){
                    // console.log('try-',error)
                    this.rediredtme(); 
                   
                }

                });

                let result = await promise; // wait until the promise resolves (*)

                //alert(result+'-'+this.$store.state.themeLogic.middle.features); // "done!"
                 this.$router.push({path:'/'})
                }

       
    }
 
};
</script>
<style scoped>
.login-box{
    margin-top: 55px;    
    padding: 10px;
}
/*.btn-login{background-color: #6b6b6b91;}*/
.badge{
    font-size: 85%;
}
.btn-login{
    background-color: #245d89 !important;    
    color: #fff !important;
}
.btn-login:focus {
    background-color: #186860 !important;
    outline: 2px dotted #e9f8ff !important;
    border: 2px dotted #1d1d1d !important;
    outline-offset: -1px !important;
}
.text-center span{
    color: #D3350D !important;
}
.text-center-align{
    text-align: center !important;
}
.bg-cover{
    background-size: cover !important; 
    background-position: center center !important;
    background-repeat: no-repeat !important;
}
.justify-content-md-center {
    -ms-flex-pack: center!important;
    -webkit-box-pack: center!important;
    justify-content: center!important;
}
@media screen and (max-width: 767px) {
    .custom_lang_chooser_outer{
        min-width: 85%;
    }

    .logo-img{
        width:50% !important;
    }
}
</style>
